/**
 * @file paddleJS Hooks
 * @author wanzhongyun
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { getCmsDataInfo } from '../../api/pages/paddleCmsGetDataApi';
import {
  RootObject
} from './type';


const usePaddleHackathonHooks = () => {
    // banner
    const [hackBanner, setHackBanner] = useState<RootObject["hackathonBanner"]>({
        backgroundImageUrl:"",
        subBackgroundImageUrl:"",
        registerWord:"",
        registerLink:"",
        detail:"",
        detailLink:""
    });
    // 活动亮点
    const [hackLight, setHackLight] = useState<RootObject["eventHighlights"]>({
        titleImg: "",
        subTitle: "",
        content: [],
        description: ""
    });
    // 时间安排
    const [hackTimeLine, setHackTimeLine] = useState<RootObject["timeArrange"]>({
        titleImg:"",
        backImg:"",
        years:"",
        describe:"",
        markImg:"",
        content: [],
        description:""
    });
    // 任务列表
    const [hackTopic, setHackTopic] = useState<RootObject["hackathonBrowseTopic"]>({
        titleImageUrl: "",
        topicList: [],
        allTopicWord: "",
        allTopicLink: ""
    });
    // 活动奖项
    const [hackAwards, setHackAwards] = useState<RootObject["hackathonAwards"]>({
        titleImageUrl: '',
        desc: '',
        detailLink: '',
        commonAwardsImg: '',
        specialAwardsImg: ''
    });
    // 立即参加
    const [hackRegister, setHackRegister] = useState<RootObject["hackathonRegister"]>({
        describe:'',
        introduce:'',
        titleImageUrl: '',
        register: '',
        registerLink: '',
        joinCom: '',
        joinComLink: ''
    });
    // 固定栏
    const [hackQRCode, setHackQRCode] = useState<RootObject["hackQRCode"]>({
        registerLink: '',
        qrCodeUrl: ''
    });
    // 主办方与合作伙伴
    const [paddleHackathonPartner, setPaddleHackathonPartner] = useState<RootObject["paddleHackathonPartner"]>({
        titleImageUrl: '',
        content: [],
        description: ''
    })
     // 往期回顾
     const [reviewPast, setReviewPast] = useState<RootObject["reviewPast"]>({
        titleImg: "",
        jumpName: "",
        jumpLink: "",
        imgList: [],
        shufflingBackImgs: "",
        content: [],
        description:""
    });
    useMount(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/PaddlePaddle-Hackathon-2024-3' })
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                // console.log(data);
                
                data.hackathonBanner && setHackBanner(data.hackathonBanner);
                data.eventHighlights && setHackLight(data.eventHighlights);
                data.timeArrange && setHackTimeLine(data.timeArrange);
                data.hackathonBrowseTopic && setHackTopic(data.hackathonBrowseTopic);
                data.hackathonAwards && setHackAwards(data.hackathonAwards);
                data.hackathonRegister && setHackRegister(data.hackathonRegister);
                // data.hackathonPartner && setHackPartner(data.hackathonPartner);
                data.hackQRCode && setHackQRCode(data.hackQRCode);
                data.reviewPast && setReviewPast(data.reviewPast);
                data.paddleHackathonPartner && setPaddleHackathonPartner(data.paddleHackathonPartner);
            }
        })();
    });
    return {
        hackBanner,
        hackLight,
        hackTimeLine,
        hackTopic,
        hackAwards,
        hackRegister,
        // hackPartner,
        hackQRCode,
        paddleHackathonPartner,
        reviewPast
    }
}

export default usePaddleHackathonHooks;